<template>
	<div>
		<SideNavBar />
		<transition name="fade-transform" mode="out-in">
			<router-view :class="menuStatus ? 'extra-width' : ''" />
		</transition>
	</div>
</template>

<script>
import SideNavBar from "../../components/fixedcomponents/sideNavBar.vue";
import { mapGetters } from "vuex";

export default {
	name: "AppMain",
	components: {
		SideNavBar,
	},
	computed: {
		...mapGetters("userVUEX", {
			menuStatus: "getMenuStatus",
		}),
	},
};
</script>

<style>
.extra-width {
	margin-left: 135px !important;
}
</style>
